import { COOKIE_LOCALE_OVERRIDE } from "@faire/web/common/consts/COOKIE_LOCALE_OVERRIDE";
import { SHOP_PREVIEW_OVERRIDE_KEY } from "@faire/web/common/consts/SHOP_PREVIEW_OVERRIDE_KEY";
import { removeCookie, setCookies } from "@faire/web/common/cookies";
import { Storage } from "@faire/web/common/Storage";
import patchUser from "@faire/web-api--source/endpoints/www/api/user/patch";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";

import { localeKeyToLocaleString } from "./localeKeyToLocaleString";

const BROWSER_LOCALE_OVERRIDE_KEY = "IF_BROWSER_LOCALE_OVERRIDE";
export const setLocale = async (
  language: keyof typeof Language,
  userToken?: string,
  localeKey?: ILocaleKey
) => {
  const newLocaleCookieValue =
    localeKey && localeKey.language
      ? localeKeyToLocaleString({
          localeKey: localeKey,
        })
      : localeKeyToLocaleString({
          localeKey: { language: language, country: undefined },
        });
  setCookies(COOKIE_LOCALE_OVERRIDE, newLocaleCookieValue);
  if (userToken) {
    if (localeKey) {
      await patchUser({ token: userToken, locale_key: localeKey });
    } else {
      await patchUser({ token: userToken, language });
    }
  }

  Storage.local.setItem(BROWSER_LOCALE_OVERRIDE_KEY, newLocaleCookieValue);
};

export const setLocaleForCookie = (
  language: keyof typeof Language,
  cookie: typeof SHOP_PREVIEW_OVERRIDE_KEY,
  localeKey?: ILocaleKey
) => {
  const newLocaleCookieValue =
    localeKey && localeKey.language
      ? localeKeyToLocaleString({
          localeKey: localeKey,
        })
      : localeKeyToLocaleString({
          localeKey: { language: language, country: undefined },
        });

  setCookies(cookie, newLocaleCookieValue);
};

export const clearLocaleOverrides = () => {
  removeCookie(COOKIE_LOCALE_OVERRIDE);
  Storage.local.removeItem(BROWSER_LOCALE_OVERRIDE_KEY);
};
